
<div [formGroup]="form">
  <ng-container *ngIf="field.range">
    <app-datePicker-WithRange [formName]="formName" [isEdit]='isEdit' [isInValid]="isInValid" [disabled]="disabled" [isReadOnly]="isReadOnly" [field]="field" [form]="form"></app-datePicker-WithRange>
  </ng-container>
  <ng-container *ngIf="!field.range">
    <app-datePicker-NoRange [formName]="formName" [isEdit]='isEdit' [field]="field" [disabled]="disabled" [isInValid]="isInValid" [form]="form"></app-datePicker-NoRange>
  </ng-container>
</div>
